var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "col-lg-3 control-label",
      staticStyle: { "padding-right": "5px" }
    },
    [
      _vm._t("default"),
      _vm._v(" : "),
      _vm.requiredAsBoolean
        ? _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }